module.exports = global["$"] = require("-!/home/gial/dev/KAV_pages/node_modules/expose-loader/index.js?jQuery!/home/gial/dev/KAV_pages/node_modules/source-map-loader/index.js!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/jquery/dist/jquery.js-exposed
// module id = 2
// module chunks = 0